import { TriangleIcon, VolumeBarIcon } from "@assets";
import { LBtn, LFlex, LModal, LSubTitle, LTitle } from "@components";
import { useEffect } from "react";

export const MicCheckOpenModal = ({
    onClose,
    startSpeechToText,
    recordingVolume
}: MicCheckOpenModalProps): JSX.Element => {
    const handleOnClose = (): void => {
        onClose?.();
    };

    const handleOnConfirm = (): void => {
        onClose?.();
    };

    useEffect(() => {
        setTimeout(() => {
            void startSpeechToText();
        }, 500);
    }, []);

    return (
        <LModal
            onClose={handleOnClose}
            onConfirm={handleOnConfirm}
            footer={
                <LFlex alignCenter justifyCenter className="mb-5">
                    <LBtn onClick={handleOnConfirm} isBold>
                        Done
                    </LBtn>
                </LFlex>
            }
            width={"m"}
            fullHeight={false}
        >
            <LFlex alignCenter justifyCenter className="p-4">
                <LTitle color="has-text-dark-blue" size="4">
                    Say the name of the shape you see on the screen
                </LTitle>
                <LFlex alignCenter justifyCenter className="mt-6">
                    <TriangleIcon />
                    <div className="mt-6">
                        <VolumeBarIcon volume={recordingVolume ?? 0} />
                    </div>
                </LFlex>
                <LSubTitle color="has-text-dark-blue" size="5" className="mt-6">
                    {"Click done after you've said the name of the shape."}
                </LSubTitle>
            </LFlex>
        </LModal>
    );
};

interface MicCheckOpenModalProps {
    onClose?: () => void;
    startSpeechToText: () => void;
    recordingVolume?: number;
}
